export default [
  {
    component: 'div',
    class: 'row',
    name: 'name',
    children: [
      {
        name: 'firstName',
        label: 'First Name *',
        validation: 'required',
        validationMessages: {
          required: 'First name is required.'
        }
      },
      {
        name: 'lastName',
        label: 'Last Name *',
        validation: 'required',
        validationMessages: {
          required: 'Last name is required.'
        }
      }
    ]
  },
  {
    component: 'div',
    class: 'row',
    name: 'emailPhone',
    children: [
      {
        name: 'email',
        label: 'Email *',
        validation: 'required|email'
      }
    ]
  },
  {
    component: 'div',
    class: 'row',
    name: 'passwords',
    children: [
      {
        type: 'password',
        name: 'password',
        label: 'Create a password *',
        validation: '^required|min:6,length'
      },
      {
        type: 'password',
        name: 'password_confirm',
        label: 'Confirm password *',
        validation: '^required|confirm|min:6,length',
        validationMessages: {
          required: 'Password confirmation is required',
          confirm: 'Passwords must match',
          min: 'Password must be at least 6 characters long'
        }
      }
    ]
  }
]